import { action } from 'utils/actions'

export const HOME_LOAD_PAGE = 'HOME_LOAD_PAGE'
export const HOME_LOAD_PAST_EVENT_GROUPS = 'HOME_LOAD_PAST_EVENT_GROUPS'

export const homeLoadPage = partnerId => action(HOME_LOAD_PAGE, { partnerId })

export const homeLoadPastEventGroups = (partnerId, nextPage = false) =>
  action(HOME_LOAD_PAST_EVENT_GROUPS, { partnerId, nextPage })



/** WEBPACK FOOTER **
 ** ./src/actions/home/home-actions.js
 **/